/** Helper condivisi per aggiornare <head> a runtime (meta/link), usati da PageMeta e NotFound. */

export function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function removeMeta(attr, key) {
  document.querySelector(`meta[${attr}="${key}"]`)?.remove();
}

export function removeLink(rel, hreflang) {
  const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  document.querySelector(selector)?.remove();
}

export function upsertLink(rel, hreflang, href) {
  const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    if (hreflang) el.setAttribute('hreflang', hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/** Sostituisce tutti i meta con questa property (per tag multi-valore, es. og:locale:alternate). */
export function replaceMetaGroup(property, values) {
  document.querySelectorAll(`meta[property="${property}"]`).forEach((el) => el.remove());
  values.forEach((content) => {
    const el = document.createElement('meta');
    el.setAttribute('property', property);
    el.setAttribute('content', content);
    document.head.appendChild(el);
  });
}
